import axiosInstance from '@/services/axiosInstance'

async function unlinkVerifactuGroupMultiple (payload = {}) {
  if (process.env.VUE_APP_ENVIRONMENT === 'test') {
    return new Promise((resolve, reject) => {
      resolve()
    })
  } else {
    const req = {
      url: 'api/grupos/desvincularregistrosgrupos',
      method: 'PUT',
      headers: {
        'Content-type': 'application/json',
        'access-control-allow-origin': '*'
      },
      data: payload
    }
    const res = await axiosInstance(req)
    return res.data
  }
}

export { unlinkVerifactuGroupMultiple }
